
import { getCoverPath } from "./utils/minioUrls";

export type AlbumInfo = {
  id: string;          // e.g. "set1"
  title: string;       // visible name
  cover: string;       // preview image (public path)
  totalLevels: number; // how many pictures in this album
};

export type ModelInfo = {
  id: string;
  fullName: string;
  welcomeMessage: string;
  publicPath: string;
  avatar: string;
  cover: string;
  albums: AlbumInfo[]; // ← NEW
};


export const models: Record<string, ModelInfo> = {
  yane: {
    id: "yane",
    fullName: "Yane the Sweetheart",
    welcomeMessage: "Hi, happy to see you here ❤️",
    publicPath: "yane",
    avatar: "/yane/avatar.png",
    cover: "/yane/cover.jpg",
    albums: [],
  },
  marry: {
    id: "marry",
    fullName: "Marry the Wild One",
    welcomeMessage: "Hey babe, ready to have some fun? 😘",
    publicPath: "marry",
    avatar: "/marry/avatar.png",
    cover: "/marry/cover.jpg",
    albums: [],
  },
  deby: {
    id: "deby",
    fullName: "Deby the Wild One",
    welcomeMessage: "Hey babe, ready to have some fun? 😘",
    publicPath: "deby",
    avatar: "/deby/deby_avatar.jpg",
    cover: "/deby/deby_cover.png",
    albums: [
      { id: "studio",  title: "Studio Session", cover: getCoverPath("deby", "studio") + "/cover.png",  totalLevels: 8 },
    ],

  },
  // Add more models here
};
